/**
 * Sentence-case a single lyric line for display, matching jnana-native's
 * `TextTransformCase.FIRST_UPPER`.
 *
 * Marker-aware: an acrostic/bandha line begins with a `%marker%` (e.g.
 * `%first% ...`) whose real first letter is the highlighted syllable INSIDE the
 * marker, not the `%` delimiter. A leading `%` is skipped so that syllable gets
 * capitalized — otherwise `'%'.toUpperCase()` is a no-op and `%first%` would
 * render lowercase even though the highlight is applied.
 *
 * Idempotent (an already-capital first letter is unchanged) and a no-op on
 * uncased scripts (Devanagari, Kannada, Telugu, …) where `toUpperCase()`
 * returns the same character — so only English/IAST lines are visibly affected.
 */
export function firstUpper(text: string): string {
  if (!text) {
    return '';
  }
  const start = text[0] === '%' ? 1 : 0;
  if (start >= text.length) {
    return text;
  }
  return `${text.slice(0, start)}${text[start].toUpperCase()}${text.slice(start + 1)}`;
}
